import { IBLSpinLoader, PathwayItems, ToastNotification } from '../../../components';
import {
  getContentCompletionData,
  getUserName,
  useProgram,
  hasUserEnrolledProgram,
  enrollUserInProgram,
} from '../../../hooks';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';

export const ProgramViewContent = ({ programID }) => {
  const [program, programLoaded, programCourses, programCoursesLoaded] =
    useProgram({ programID });
  const [isEnrolled, setIsEnrolled] = useState<boolean>(false);
  const [isEnrollmentChecked, setIsEnrollmentChecked] = useState<boolean>(false);
  const [isEnrolling, setIsEnrolling] = useState<boolean>(false);
  const descriptionContent = program?.data?.description ?? '';

  const { t } = useTranslation('library');

  const [completionData, setCompletionData] = useState({
    completion_percentage: null,
    count: 0,
  });

  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [notificationType, setNotificationType] = useState<'success' | 'error'>('success');

  const handleCompletionDataFetch = () => {
    getContentCompletionData(
      {
        program_key: program?.program_key,
        username: getUserName(),
      },
      'program',
      (data) => {
        setCompletionData({
          completion_percentage: Math.floor(data.completion_percentage),
          count: data?.count,
        });
      }
    );
  };

  const handleEnrollProgram = (e: React.MouseEvent) => {
    e.preventDefault();
    if(isEnrolling){
      return;
    }
    setIsEnrolling(true);
    enrollUserInProgram(programID, (successful) => {
      setIsEnrolling(false);
      if(successful){
        setIsEnrolled(true);
        setNotificationMessage('Successfully enrolled in program!');
        setNotificationType('success');
        setShowNotification(true);
      } else {
        setNotificationMessage('Failed to enroll in program. Please try again.');
        setNotificationType('error');
        setShowNotification(true);
      }
    });
  };

  useEffect(() => {
    if (programLoaded && program?.program_key) {
      handleCompletionDataFetch();
      hasUserEnrolledProgram(programID, (enrolled) => {
        setIsEnrolled(enrolled);
        setIsEnrollmentChecked(true);
      });
    }
  }, [programLoaded, program?.program_key]);

  return (
    <div className="pathway">
      {showNotification && (
        <ToastNotification
          message={notificationMessage}
          type={notificationType}
          onClose={() => setShowNotification(false)}
        />
      )}
      <div className="div-block-110">
        <div className="pathway_div">
          <div className="div-block-121">
            {completionData?.completion_percentage ? (
              <div className="content-progress-bar-block-container">
                <div className="w-layout-vflex content-progress-bar-block full-floating">
                  <div className="w-layout-hflex content-progress-bar-top-block font-bigger">
                    <div className="w-layout-hflex flex-block-67">
                      <img
                        src="/images/circle-check-big.svg"
                        loading="lazy"
                        alt=""
                        className="image-240"
                      />
                      <div className="content-progress-bar-title">Progress</div>
                    </div>
                    <div className="content-progress-bar-percentage">
                      {completionData?.completion_percentage}%
                    </div>
                  </div>
                  <div className="content-progress-bar-slider-block more-height">
                    <div
                      className="content-progress-bar-slider-percentage-block"
                      style={{
                        width: `${completionData?.completion_percentage}%`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="text-block-58">
            {programLoaded ? program?.name : ''}
          </div>
          <div className="div-block-75">
            <div className="p_header">
              <div className="text-block-39 wide p_t wt">
                {programLoaded ? program?.name : ''}
              </div>
              <div
                className="unit-wide-description people profile_description p_t wto"
                prop-data-names="stat"
                prop-data-value-stat="32 Items - 8 sections - 7 Hours"
              >
                {programCoursesLoaded
                  ? `${programCourses?.length || 0} ${' ' + t('Courses')}`
                  : ''}
              </div>
            </div>
          </div>
        </div>
        {(descriptionContent || !isEnrolled) && (
          <div className="p_about program-about-container">
            {descriptionContent && (
              <div className="text-block-57" prop-data-names="description">
                {descriptionContent}
              </div>
            )}
            {!isEnrolled && isEnrollmentChecked && (
              <a
                className={`button-5 w-button w-button program-enroll-btn ${!descriptionContent ? 'centered-button' : ''}`}
                href="#"
                onClick={handleEnrollProgram}
              >
                {isEnrolling ? <IBLSpinLoader size={25} color='#fff' /> : 'Enroll'}
              </a>
            )}
          </div>
        )}
      </div>
      <div className="p_outline">
        {!programCoursesLoaded ? (
          <IBLSpinLoader size={40} containerHeight={'200px'} />
        ) : (
          programCourses.map((data, index) => {
            return <PathwayItems key={index} data={data} index={index} />;
          })
        )}
      </div>
    </div>
  );
};
